"use strict";
(function (global) {

  /**
   * Установить пользовательский статус для объекта.
   *
   * @function WebAccess.services.entity.setUserStatus
   * @param {object} obj Объект вида {{id: 'ИД', kind: 'Тип', refcode: 'Код справочника'}}
   * @param {string} StatusName Наименование пользовательского статуса
   * @return {Deferred} deferred-объект для управления отложенными вызовами.
   * @example
   *
   * //Установить пользовательский статус текущего объекта – «Зеленый».
   * WA.services.entity.setUserStatus({"kind": WA.CR.getKind(), "id": WA.CR.getID()}, "Green");
   */
  global.entity.setUserStatus = function (obj, StatusName) {
    return global.call("/Entity.asmx/SetUserStatus", {
      "Kind": obj.kind,
      "ID": obj.id,
      "StatusName": StatusName
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess.services);
